export const DEACTIVATE_COMPANY_REQUEST = 'DEACTIVATE_COMPANY_REQUEST';
export const DEACTIVATE_COMPANY_REQUEST_FAILURE = 'DEACTIVATE_COMPANY_REQUEST_FAILURE';
export const DEACTIVATE_COMPANY_REQUEST_SUCCESS = 'DEACTIVATE_COMPANY_REQUEST_SUCCESS';

export const GET_COMPANY_REQUEST = 'GET_COMPANY_REQUEST';
export const GET_COMPANY_REQUEST_FAILURE = 'GET_COMPANY_REQUEST_FAILURE';
export const GET_COMPANY_REQUEST_SUCCESS = 'GET_COMPANY_REQUEST_SUCCESS';

export const GET_COMPANY_LOGO_REQUEST = 'GET_COMPANY_LOGO_REQUEST';
export const GET_COMPANY_LOGO_REQUEST_FAILURE = 'GET_COMPANY_LOGO_REQUEST_FAILURE';
export const GET_COMPANY_LOGO_REQUEST_SUCCESS = 'GET_COMPANY_LOGO_REQUEST_SUCCESS';

export const SELECT_COMPANY_ENTITY_REQUEST = 'SELECT_COMPANY_ENTITY_REQUEST';
export const SELECT_COMPANY_ENTITY_REQUEST_FAILURE = 'SELECT_COMPANY_ENTITY_REQUEST_FAILURE';
export const SELECT_COMPANY_ENTITY_REQUEST_SUCCESS = 'SELECT_COMPANY_ENTITY_REQUEST_SUCCESS';

export const UPDATE_COMPANY_REQUEST = 'UPDATE_COMPANY_REQUEST';
export const UPDATE_COMPANY_REQUEST_FAILURE = 'UPDATE_COMPANY_REQUEST_FAILURE';
export const UPDATE_COMPANY_REQUEST_SUCCESS = 'UPDATE_COMPANY_REQUEST_SUCCESS';
